
import dayjs from "dayjs"
import { divide } from "number-precision"
import { modifyCartV2 } from "../../api/cart"
import unableItem from "./unable-item"
import unableItemDialog from "./unable-item-dialog.vue"
import { getLanguage } from "@/plugins/i18n"

// 将数组数据分行
function arrayToRow(arr, row = 3) {
  if (!arr) return []
  const result = []
  let output = []
  for (let i = 0; i < arr.length; i++) {
    if (i % row === 0 && i !== 0) {
      result.push([...output])
      output = [arr[i]]
    } else {
      output.push(arr[i])
    }
  }
  result.push([...output])
  return result
}

export default {
  components: {
    unableItem,
    unableItemDialog
  },
  props: {
    shipTimeItemList: {
      type: Array,
      default: () => []
    },
    storeId: {
      type: [String, Number],
      default: ""
    },
    timeIsActive: {
      // 是否选过时间
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeText: "",
      isShow: true,
      rowIndex: 0,
      list: []
    }
  },
  watch: {
    shipTimeItemList: {
      handler(newVal) {
        const selected1 = newVal.find(v => v.selected)
        const selected2 = selected1 && selected1.timeList_ ? selected1.timeList_.find(v => v.selected) : null
        if (selected1 && selected2) {
          // this.activeText = selected1.dateText + ' At ' + selected2.value;
          this.activeText = this.getViewDate(selected1.date) + ", " + selected2.value
        }
        newVal = this.formatDateText(newVal)
        newVal = this.addEmptyTimeRange(newVal)
        newVal = this.getRecommendDateToFront(newVal)
        this.list = arrayToRow(newVal, 3)
        console.log(this.list)
      },
      immediate: true
    }
  },
  methods: {
    _formatFee(val) {
      if (val) {
        return "$" + divide(Number(val), 100)
      }
      return this.$t("checkout.free")
    },
    getRecommendDateToFront(timeRange) {
      if (timeRange) {
        const recommend = timeRange.find(v => v.dateDeliveryStatus == 100)
        if (recommend) {
          const fisrt = {
            ...recommend,
            flag: "isRecommend"
          }
          fisrt.timeList_ = fisrt.timeList_.filter(v => v.timeSlotStatus != 2 && v.timeSlotStatus != 3)
          timeRange.unshift(fisrt)
        }
      }
      return timeRange
    },
    addEmptyTimeRange(timeRange) {
      if (timeRange.length < 2) return timeRange
      const newTimeRange = []
      let preTimeRange = timeRange[0]
      newTimeRange.push(preTimeRange)
      let curTimeRange
      let i = 1
      let count = 0
      while (i < timeRange.length) {
        if (count > 10) break // 最多循环10次，防止循环不终止
        const nextDate = dayjs(preTimeRange.date).add(1, "day").format("YYYY-MM-DD")
        if (timeRange[i].date === nextDate) {
          curTimeRange = timeRange[i]
          newTimeRange.push(curTimeRange)
          i++
        } else {
          const day = dayjs(nextDate)
          curTimeRange = {
            date: nextDate,
            dateText:
              getLanguage() == "en_US"
                ? `${this.$t("checkout.week")[day.day()]}, ${day.date()} ${this.$t("checkout.month")[day.month()]}`
                : `${this.$t("checkout.month")[day.month()]}${day.date()}日（${this.$t("checkout.week")[day.day()]}）`,
            selected: false,
            timeList_: []
          }
          newTimeRange.push(curTimeRange)
        }
        preTimeRange = curTimeRange
        count++
      }
      return newTimeRange
    },
    getViewDate(date) {
      date = dayjs(date)
      return getLanguage() == "en_US"
        ? `${this.$t("checkout.week")[date.day()]}, ${date.date()} ${this.$t("checkout.month")[date.month()]}`
        : `${this.$t("checkout.month")[date.month()]}${date.date()}日（${this.$t("checkout.week")[date.day()]}）`
    },
    formatDateText(timeRange) {
      return (
        timeRange &&
        timeRange.map(v => {
          const day = dayjs(v.date)
          return {
            ...v,
            dateText:
              getLanguage() == "en_US"
                ? `${this.$t("checkout.week")[day.day()]}, ${day.date()} ${this.$t("checkout.month")[day.month()]}`
                : `${this.$t("checkout.month")[day.month()]}${day.date()}日（${this.$t("checkout.week")[day.day()]}）`
          }
        })
      )
    },
    choseTime(v, item) {
      if (item.timeSlotStatus == 3) return
      if (item.timeSlotStatus == 2) {
        this.$refs.unableItem.open({
          list: item.unAvailableItems,
          curDate: v,
          curTime: item
        })
        return
      }
      this.afterChoseTime(v, item)
    },
    afterChoseTime(v, item) {
      // this.activeText = v.dateText + ' At ' + item.value;
      this.activeText = this.getViewDate(v.date) + ", " + item.value
      this.$emit("changed", {
        shipmentDate: v.date,
        shipmentTime: item.value
      })
    },
    async handleUnableItemConfirm(res) {
      await this.modifyCartV2(res.list)
      this.$refs.unableItemDialog.open().then(val => {
        if (val === "left") {
          this.$navigation.replace({
            path: "/cart"
          })
        }
        if (val == "right") {
          this.afterChoseTime(res.curDate, res.curTime)
          this.$refs.unableItem.close()
        }
      })
    },
    async modifyCartV2(list) {
      const params = {
        isCollage: false,
        sort: 0,
        simple: 1,
        storeGroup: [
          {
            erpStoreId: this.storeId,
            wares: list.map(v => ({
              sku: v.sku,
              checked: 0,
              beforeCount: v.count,
              count: v.count
            }))
          }
        ]
      }
      try {
        await modifyCartV2({ param: JSON.stringify(params) })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    handleBack() {
      this.rowIndex--
    },
    handleForward() {
      this.rowIndex++
    }
  }
}
